import 'jquery';

import * as snippet from './snippet/snippet.js';
import * as operationFilters from './filters/operationFilters.js';
import * as recaptcha from './recaptcha.js';
import * as commonFunctions from './contactAgencyCommonFunctions.js';

var originalOverflowPopup;
var originalWidthPopup;
var originalPaddingBottomPopup;
var originalHeaderPosition;
var originalH1Position;
var floatingAlertTop;

function onReadyMethod(){
    operationFilters.init();
    snippet.init();
    createFavouriteEvents();

	// favouriteForLoggedUserEvents();
	$('.filtros .filtrar').click(function(e) {
		openFilterDiv(e);
	});

  $('.go-to-ad-container p').on('click', function(){
  	window.location = $(this).closest('.ag-detail').find('a').prop('href');
  })
  eventGoToAd();
  seeMoreDescription();
}


function eventGoToAd() {
  $('.ag-goToAd').on('click', function(){
 		window.location = $(this).closest('.aggregator-big').find('a').prop('href');
 	});
}
function seeMoreDescription() {
	var agDesc = $(".ag-description");
	agDesc.css({ overflow: "auto", display: "table" });
 	var overDesc1 = $(".ag-description").outerHeight();
 	agDesc.css({overflow:"hidden", display:"block"});
 	var overDesc2 = agDesc.outerHeight();
 	if (overDesc1 > overDesc2) {
 		$(".ag-seeMore").css("display","flex");
 	}
}
function redirectFilter(url) {
	window.location.href = url;
}
function setVideo(id) {
	console.log('setting video for id:' + id)
	if (id) {
		videojs(id,{}, function(){
			var videojs_player = this;
		    videojs_player.on("click", function(event){
		    });

		})
		.ready(function() {
			// Store the video object
			var myPlayer = this, id = myPlayer.id();
			// Make up an aspect ratio
			// var aspectRatio = 264/640;
			var aspectRatio = 310 / 551;
			function resizeVideoJS() {
				var width = document.getElementById(id).parentElement.offsetWidth;
				myPlayer.width(width).height(
						width * aspectRatio);
			}
			// Initialize resizeVideoJS()
			resizeVideoJS();
		});
	}
}
function closeAggregatorDetailPayment() {
	$('.menu__layer').removeClass('is-active');
	var popupContacto = $('.pop-up-contacto');
	popupContacto.removeClass('is-active').trigger('contacto:close');
	popupContacto.css("overflow",originalOverflowPopup).css("width",originalWidthPopup)
				.css("padding-bottom",originalPaddingBottomPopup).removeClass('adRecommended');
}

function checkScroll() {
	$(document).scroll(function() {
		changeFloatingByScrollPosition();
	});
}
function changeFloatingByScrollPosition() {
	if ($( window ).width()<1200) {
		var headerEle = $('header');
		var preViviendas = $('section.pre-viviendas');
		if ($(document).scrollTop() > originalHeaderPosition) {
			headerEle.addClass("floating-fixed");
		} else {
			headerEle.removeClass("floating-fixed");
		}
		if ($(document).scrollTop() > originalH1Position) {
			headerEle.addClass("no-box-shadow");
			preViviendas.addClass("floating-fixed").css("cssText", "top: " + $('header').outerHeight() + "px !important");
		} else {
			headerEle.removeClass("no-box-shadow");
			preViviendas.removeClass("floating-fixed").css("cssText", "top: 0 !important");
		}
	} else {
		var floatingAlert = $('.floating-alert');
		if (typeof floatingAlertTop === 'undefined') {
			floatingAlertTop = $('.floating-alert').position().top;
		}
		if ($(document).scrollTop() >= floatingAlertTop) {
			floatingAlert.addClass("floating-fixed");
		} else {
			floatingAlert.removeClass("floating-fixed");
		}
	}
}
function defineDevice() {
	var containerBody = $('.container-body');
	containerBody.removeClass('mobile').removeClass('tablet');
	if ($( window ).width()<=764) {
		containerBody.addClass("mobile");
	} else if ($( window ).width()<=1024) {
		containerBody.addClass("tablet");
	}
}
function openOrderByDiv (e) {
	if (!$(".button-ordenar__list").hasClass('active')) {
		try {
			analytics.submitEventAction(awp, analyticsObjects.actions.open, analyticsObjects.labelElements.orderBy);
		} catch(e) {;}

		$(".button-ordenar__list").addClass('active');
		if ($( window ).width()<1200) {
			$(body).addClass("blocking");
			$('.menu__layer').addClass('is-active');
			$('.pre-viviendas.floating-fixed').addClass('orderBy');
			setPreventAndPropagation(e);

			$('.menu__layer.is-active').on("click", function(e) {
				setPreventAndPropagation(e);
	  			closeOrderByDiv()
		    });
			$('.button-ordenar__list.active').on('click', '.title', function (e) {
				setPreventAndPropagation(e);
				closeOrderByDiv();
			});
		}
	} else {
		closeOrderByDiv();
	}
}
function closeOrderByDiv() {
	$(".button-ordenar__list").removeClass('active');
	if ($( window ).width()<1200) {
		$(body).removeClass("blocking");
		$('.menu__layer').removeClass('is-active');
		$('.pre-viviendas.floating-fixed').removeClass('orderBy');
		$('.button-ordenar__list.active').off('click', '.title');
		$('.menu__layer.is-active').off("click");
	}
}
function openFilterDiv(e) {
	try {
		analytics.submitEventAction(awp, analyticsObjects.actions.open, analyticsObjects.labelElements.filter);
	} catch(e) {;}

	$('.filtro').addClass("active");
	$(body).addClass("blocking");
	$('.menu__layer').addClass('is-active');
	setPreventAndPropagation(e);

	$('.menu__layer.is-active').on("click", function(e) {
		setPreventAndPropagation(e);
		closeFilterDiv()
    });
	$('.filtro.active').find('.filtrar').on('click', function (e) {
		setPreventAndPropagation(e);
	  	closeFilterDiv();
	});
}
function closeFilterDiv(e) {
	$('.filtro').removeClass("active");
	$(body).removeClass("blocking");
	$('.menu__layer').removeClass('is-active');
	$('.filtro.active').find('.filtrar').off('click');
	$('.menu__layer.is-active').off("click");
}



function generatePhoneContact(obj, recaptchaToken) {
	var partner = obj.attr('data-partner');
	var pvParams = getPvParams();
	if(typeof pvParams == 'undefined' || pvParams.length == 0) {
		pvParams = obj.attr("pvParams");
	}
	var contactSubtypeName = 'ADS_LISTING';
	if ($('article.ag-detail').length>0 || $('article.ag-article').length>0) {
		contactSubtypeName = 'AGGREGATOR_DETAIL_AD_PAYMENT_LISTING';
		if ($(obj).parents('li.ad.similar').length>0) {
			contactSubtypeName += '_SIMILAR';
		} else if ($(obj).parents('li.ad.premier').length>0) {
			contactSubtypeName += '_PREMIUM';
		}
	} else {
		if ($(obj).parents('li.ad.similar').length>0) {
			contactSubtypeName = 'ADS_SIMILAR';
		} else if ($(obj).parents('li.ad.premier').length>0) {
			contactSubtypeName = 'ADS_PREMIUM_LISTING';
		}
	}
	contactSubtypeName += '_PHONE';
	var params={
		adId:obj.attr('data-adId'),
		wantsAlerts:false,
		partner:partner,
		token:recaptchaToken,
		where: obj.attr('data-where'),
		contactSubtypeName: contactSubtypeName,
		pvParams:pvParams,
        gaPageType: gaPageType,
        listingPosition: $(obj).parents('li').index() + 1,
        titlePage: ($('.pre-viviendas h1').text())
	}

	showPopUp('/generatePhoneContact',params, function(response, status, xhr){

		if (status !== 'error') {
			$('#submitPhoneForm').on('click', function (e) {
				e.preventDefault();
				let id = '#viewFormPhone';
				$(id).find('.has-error').each(function (index, elem) {
					$(this).removeClass('has-error');
				})
				var ret = true;
				$(id + " [required='required']").each(function () {
					if (commonFunctions.toggleError($(this).attr("data-type"), $(this)))
						ret = false;
				});
				if (ret) {
					var $form = $(this).parents('form');
					// Si no carga la libreria de validacion el telefono se valida igual, con la comprobacion basica
					var validateAndSend = function () {
						var phone = validPhoneOf($(id + " input[id^='phone-']"));
						if (phone === null) {
							return false;
						}
						var params = {
							adId: $form.find('input[name="adId"]').val(),
							wantsAlerts: $form.find('input[name="wantsAlerts"]').is(':checked'),
							partner: partner,
							token: recaptchaToken,
							where: $form.find('input[name="where"]').val(),
							contactSubtypeName: $form.find('input[name="contactSubtypeName"]').val(),
							pvParams: getPvParams(),
                                gaPageType: gaPageType,
                                listingPosition: $(obj).parents('li').index() + 1,
                                titlePage: ($('.pre-viviendas h1').text())
						}
						params.phoneParam = phone;
						if ($form.find('input[name="name-phone"]').length > 0) {
							params.name = $form.find('input[name="name-phone"]').val();
						}
						showPopUp('/generatePhoneContact', params, function () {
							rememberUserPhone(params.phoneParam);
							eventP();
						});
					};
					loadPhoneValidationLibThen(validateAndSend, validateAndSend);
				} else {
					return false;
				}
			});
		} else {
			$('.pop-up-contacto').html('<div class="text">Se ha producido un error al tramitar tu petición</div>');
		}
		eventP();
	});
}

function showPopUp(url, parameters, beforeLoad){
	$('.pop-up-contacto').load(url, parameters, function(response, status, xhr){
		$('.pop-up-contacto').addClass('is-active');
		$('.menu__layer').addClass('is-active');
		$('body').addClass('blocking');
		$('.ui-link-0').on('click', function(e){
			e.preventDefault();
			$('.menu__layer').removeClass('is-active');
			$('body').removeClass('blocking');
			$('.pop-up-contacto').empty();
			$('.pop-up-contacto').removeClass('is-active');

			$(document).trigger('pop-up-closed');
		})
		$('.menu__layer').on('click',function(){
			$('.menu__layer').removeClass('is-active');
			$('.pop-up-contacto').removeClass('is-active');
			$(body).removeClass("blocking");
			$('.pop-up-contacto').trigger('contacto:close');

			$(document).trigger('pop-up-closed');
		});

		if(typeof beforeLoad==="function")
			beforeLoad(response, status, xhr);
	})
}
var ft_element = 'phone' + '-' + 'text';
function eventP() {

    if (typeof agencyType !== "undefined") {
        commonFunctions.saveGoogleConversionFor(agencyType);
    }
    $('.pop-up-agencyPhone').find('.'+ft_element).each(function () {
		 if (this.id) {
			 $(this).append(' - ' + hex2a(this.id.split('').reverse().join('')));
		 }
	});
}

function paginationGoto(e, obj) {
	setPreventAndPropagation(e);
	try {
		analytics.submitEventAction(awp, analyticsObjects.actions.gotoAction, analyticsObjects.labelElements.pagination+'-'+$(obj).attr('title').toLowerCase()+'-'+$(obj).closest('ul').find('li.current').find('*:first-child').text() + '-' + $(obj).closest('ul').data('tp'));
	} catch(e) {;}
	if ($(obj).hasClass('spanFilter')) {
		launchingRefresh(obj.id);
	} else {
		window.location.href=obj.href;
	}
}

var objToGeneratePhoneContact;
$(document).ready(function() {
	onReadyMethod();
	$('.button-ordenar__list li').click(function(e) {
		e.preventDefault();
		if ($(this).hasClass('title')) {
			$(".button-ordenar__list").toggleClass('active');
			if ($(".button-ordenar__list").hasClass('active')) {
				try {
					analytics.submitEventAction(awp, analyticsObjects.actions.open, analyticsObjects.labelElements.orderBy);
				} catch(e) {;}f
			}
			$(body).toggleClass("blocking");
		} else {
			try {
				analytics.submitEventAction(awp, analyticsObjects.actions.gotoAction, analyticsObjects.labelElements.orderBy+'-'+$(this).text().toLowerCase().replace(/ /g, '_').replace(/:/g, '_').replace(/__/g, '_'));
			} catch(e) {;}

			$('#param-sortBy').val($(this).attr('data-sort'));
			$("#searchLocationFilterForm").submit();
		}
	});
	contactAgency.setContactEvent();
	contactAgency.setResourcesCheckboxes();
	$('.titulo a').on('click', function(e) {
		e.preventDefault();
	});
	$('.vivienda-left').on('click', function(e) {
		if($(this).find('video').length > 0)
			e.stopPropagation();
	});
	var videoList = $('.video-js');
	if(videoList.length > 0) {
		$.getScript('/js/video.js',function(script, textStatus ) {
		    console.log( textStatus );
			videoList.each(function(index, elem) {
				setVideo(elem);
			});
		}).fail(function( jqxhr, settings, exception ) {
		    console.log( "Triggered ajaxError handler." );
		});
	}

	if ($('.ag-detail').length>0 && $('.ag-detail').attr('adId') &&  $(window).width()>=1200) {
		var popupContacto = $('.pop-up-contacto');
		popupContacto.empty();
		var executeAI = false;
		if (!findCookie("pvad")) {
			executeAI = true;
		}
		popupContacto.load('/www/resem/aggregatorDetailPayment',{
			adId : $('.ag-detail').attr('adId'),
			aggregator: aggregator,
			pvParams:getPvParams(),
			executeAI:executeAI
		}, function(data){
			if (data!='ERROR' && data!='SIMILAR_AD_NOT_LOCATED') {
				document.cookie= "pvad=" + $(body).attr("data-pvId");
				popupContacto.addClass('is-active');
				$('.menu__layer').addClass('is-active');
				$(document).scrollTop(0);
				popupContacto.addClass('adRecommended');
				originalOverflowPopup = $('.pop-up-contacto').css("overflow");
				originalWidthPopup = $('.pop-up-contacto').css("width");
				originalPaddingBottomPopup = $('.pop-up-contacto').css("padding-bottom");
				popupContacto.prepend($(document.createElement("div")).addClass('close').html('X Cerrar'));
				popupContacto.prepend($(document.createElement("div")).addClass('title').html('Anuncio recomendado'));
				seeMoreDescription();
				popupContacto.css("overflow","hidden").css("width","1200px").css("padding-bottom","0px");
				$('.pop-up-contacto > .close').click(function () {
					closeAggregatorDetailPayment();
				});

				$('.menu__layer').on('click',function(){
					closeAggregatorDetailPayment();
				});
				contactAgency.setContactEvent();
				contactAgency.setResourcesCheckboxes();
				eventGoToAd();
				try {
					launchEvents();
				} catch(e) {;}
				if(typeof analytics !='undefined') {
					analytics.submitSendContactOpen('aggregator-ad-recommended');
				}
			} else {
				closeAggregatorDetailPayment();
			}
		});
	}

	$('.pagination > li').off("click", '.uExternalRefresh');
	$('.pagination > li').on('click', 'a, span', function (e) {
		paginationGoto(e, this);
	});

	defineDevice();

	if (typeof originalHeaderPosition === 'undefined') {
		originalHeaderPosition = $('header').offset().top;
	}
	if (typeof originalH1Position === 'undefined') {
		originalH1Position = $('section.pre-viviendas').offset().top - $('header').outerHeight();
	}

	checkScroll();
	changeFloatingByScrollPosition();
	$( window ).resize(function() {
		$(document).off('scroll');
		defineDevice();
		$('.floating-fixed').each(function () {
			$(this).removeClass("floating-fixed");
		});
		checkScroll();
		changeFloatingByScrollPosition();
	});

	$('.ill').lazy();
	$(".js-btn-ordenar").on("click", function(e) {
		openOrderByDiv(e);
	});


	$('.btn-phone').on('click',function(e){
		setPreventAndPropagation(e);
		var button = $(this);
		button.text(processingText);
        objToGeneratePhoneContact = $(this);
		objToGeneratePhoneContact.attr("pvParams",getPvParams());
        recaptcha.executeCaptcha(
            () => generatePhoneContact(objToGeneratePhoneContact, null),
            () => button.text(callButtonText)
        );
	});
});



recaptcha.onLoadRecaptcha(function(token) {
    generatePhoneContact(objToGeneratePhoneContact, token);
})


